"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.passwordSchema = passwordSchema;
exports.passwordInputSchema = passwordInputSchema;
const zod_1 = require("zod");
function passwordSchema({ translations }) {
    const required = translations.fieldRequired('password');
    return zod_1.z.preprocess(value => (value === '' || value == null ? undefined : value), zod_1.z
        .string({ error: () => required })
        .min(8, translations.minCharsN(8, 'password'))
        .max(99, translations.maxCharsN(99, 'password'))
        .regex(/^[\S]+.*[\S]+$/, translations.beginEndWhiteSpace('password'))
        .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\S]+$/, translations.enforcedRule('password')));
}
function passwordInputSchema({ translations, }) {
    return zod_1.z.object({
        password: passwordSchema({ translations }),
    });
}
//# sourceMappingURL=password.js.map